export const initContact = async () => {

  $(document).ready(function ($){
    $.validator.addMethod("intlTelNumber", function (value, element) {
      let isHavePlusSign = value.match(/[+]/);
      if (value != '') {
        if (isHavePlusSign) {
          return value.match(/^[+]{1}[0-9 ]+$/);
        } else {
          return value.match(/^[0-9 ]+$/);
        }
      }
      return true;
    }, "test");

    jQuery.validator.addMethod("iv_recapcha_valid", function(value, element) {
      return (value != '');
    }, 'No message needed, grecaptcha excecuted');

    $.validator.addMethod('checkEmail', function (value, element) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(value);
    }, 'Recaptcha required');



    /*---------------------------------------------*/
    /*----------------/Contact modal-contact ------*/
    /*---------------------------------------------*/
    var contactName = 'modal-contact'
    $(`form#${contactName}`).validate({
      rules: {
        'firstname': {
          required: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
        'lastname': {
          required: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
        'phone':{
          required: true,
          intlTelNumber: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
        'email':{
          required: true,
          checkEmail: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
        'message':{
          required: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
        'g-recaptcha-response': {
          iv_recapcha_valid: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        }
      },
      messages: {
        'firstname': $('#meessageinValidRequired').val(),
        'lastname': $('#meessageinValidRequired').val(),
        'name': $('#meessageinValidRequired').val(),
        'address': $('#meessageinValidRequired').val(),
        'phone': {
          'required': $('#meessageinValidRequired').val(),
          'intlTelNumber': $('#messageinValidPhone').val()
        },
        'email': {
          'required': $('#meessageinValidRequired').val(),
          'checkEmail': $('#meessageinValidEmail').val(),
          'email': $('#meessageinValidEmail').val()
        },
        'message': $('#meessageinValidRequired').val(),
        'g-recaptcha-response': $('#meessageinValidRequired').val(),
      }
    });
    $(`form#${contactName}`).on('submit',function (e){
      e.preventDefault();
      if (grecaptcha.getResponse() == "") {
        $('.hiddenRecaptcha').show();
      }
      if($(this).valid() && grecaptcha.getResponse() != ""){
        $('.contact-form__card-wrap').fadeOut();
        $('.loading-container').fadeIn();
        $.ajax({
          url: `${window.origin}/tp-contact/submit`,
          data: $(this).serialize(),
          method: `POST`,
          error: function (e){
            $('#imageMessageSuccess').hide();
            $('#imageMessageFailed').show();
            $('#textMessage').text($('#messageFailed').val());
            $('#textMessageSecondary').hide();


            $('.loading-container').hide();
            $('.message-container').show();
          },
          success: function (data){
            $('#imageMessageSuccess').show();
            $('#imageMessageFailed').hide();
            $('#textMessage').text($('#messageSuccess').val());
            $('#textMessageSecondary').text($('#messageSuccessSecondary').val());
            $('#textMessageSecondary').show();
            $('.loading-container').hide();
            $('.message-container').show();

            $('.loading-container').fadeOut();
            $('.text-message-container').fadeIn();

          }
        })
      }
    })


    /*---------------------------------------------*/
    /*----------------node-contact ----------------*/
    /*---------------------------------------------*/
    let contactNode = 'node-contact';
    if ($(`form#${contactNode}`).length) {
      $(`form#${contactNode}`).validate({
        rules: {
          'name': {
            required: true,
            normalizer: function (value) {
              return $.trim(value);
            }
          },
          'address': {
            required: true,
            normalizer: function (value) {
              return $.trim(value);
            }
          },
          'phone':{
            required: true,
            intlTelNumber: true,
            normalizer: function (value) {
              return $.trim(value);
            }
          },
          'email':{
            required: true,
            checkEmail: true,
            normalizer: function (value) {
              return $.trim(value);
            }
          },
          'message':{
            required: true,
            normalizer: function (value) {
              return $.trim(value);
            }
          },
        },
        messages: {
          'firstname': $('#meessageinValidRequired').val(),
          'name': $('#meessageinValidRequired').val(),
          'message': $('#meessageinValidRequired').val(),
          'address': $('#meessageinValidRequired').val(),
          'phone': {
            'required': $('#meessageinValidRequired').val(),
            'intlTelNumber': $('#messageinValidPhone').val()
          },
          'email': {
            'required': $('#meessageinValidRequired').val(),
            'checkEmail': $('#meessageinValidEmail').val(),
            'email': $('#meessageinValidEmail').val()
          },
          'recaptcha': $('#meessageinValidRequired').val(),
        },
      });
    }
    $(`form#${contactNode}`).on('submit',function (e){
      e.preventDefault();
      if (grecaptcha.getResponse() == "") {
        $('.hiddenRecaptcha').show();
      }
      if($(this).valid() && grecaptcha.getResponse() != ""){
        $('.form-contact-body').addClass('hide');
        $('.loading-container').removeClass('hide');
        let form_data = {
          //contact data
          purpose: 'AskAQuestion',
          firstname: $('#name').val(),
          email: $('input#email').val(),
          phone: $('#phone').val(),
          address: $('#address').val(),
          subject: $('.realisations__content-title').text(),
          'g-recaptcha-response': grecaptcha.getResponse(),
          message: $('#message').val(),
        };
        $.ajax({
          url: `${window.origin}/tp-contact/submit`,
          data: form_data,
          method: `POST`,
          error: function (e){
            $('#imageMessageSuccess').hide();
            $('#imageMessageFailed').show();
            $('#textMessage').text($('#messageFailed').val());
            $('#textMessageSecondary').hide();
            $('.loading-container').addClass('hide');
            $('.message-container').removeClass('hide');
            console.log(`Error Submit Form`)
          },
          success: function (data){
            $('#imageMessageSuccess').show();
            $('#imageMessageFailed').hide();
            $('#textMessage').text($('#messageSuccess').val());
            $('#textMessageSecondary').text($('#messageSuccessSecondary').val());
            $('#textMessageSecondary').show();
            $('.loading-container').addClass('hide');
            $('.message-container').removeClass('hide');
            console.log(data)
            console.log(`Ok Submit Form`)
          }
        })
      }
    })

    $('#closeMessageButton').on('click', function (e){
      e.preventDefault();
      location.reload();
    })
  })
}
